export default "__VITE_PUBLIC_ASSET__49877ba4__"